import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';

const GoLight: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('GoLight');

    const image1Map: any = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753697946437/1-pc.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753697946133/1-pad.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753697946601/1-h5.png',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753697946437/1-pc.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753697946133/1-pad.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753697946601/1-h5.png',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784631510-hyh3ur-compressed-8_1%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784652251-bxgq8o-compressed-8_1%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784673160-4em2f7-compressed-8_1%20IMG.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784631510-hyh3ur-compressed-8_1%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784652251-bxgq8o-compressed-8_1%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784673160-4em2f7-compressed-8_1%20IMG.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784762490-3mtgtv-compressed-8_1%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784774313-9lznd3-compressed-8_1%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784786449-btujuk-compressed-8_1%20IMG.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784842911-9grxd3-compressed-8_1%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784855366-yr1sbx-compressed-8_1%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784868266-3vhv4b-compressed-8_1%20IMG.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784927770-g2lfyt-compressed-8_1%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784938153-dgqgce-compressed-8_1%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784950185-qot0xg-compressed-8_1%20IMG.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756785002627-0khjeh-compressed-8_1%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756785015938-bq8nj5-compressed-8_1%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756785028854-7jtvin-compressed-8_1%20IMG.jpg',
        },
        ph: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753697946437/1-pc.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753697946133/1-pad.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753697946601/1-h5.png',
        },
    };

    const image2Map: any = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753697945699/2-pc.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753697945895/2-pad.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753697945544/2-h5.png',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753697945699/2-pc.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753697945895/2-pad.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753697945544/2-h5.png',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784694973-7qsgxx-compressed-8_2%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784711443-ww924i-compressed-8_2%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784724938-37uzt1-compressed-8_2%20IMG.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784694973-7qsgxx-compressed-8_2%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784711443-ww924i-compressed-8_2%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784724938-37uzt1-compressed-8_2%20IMG.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784802874-ii79jl-compressed-8_2%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784814155-cdx3b1-compressed-8_2%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784825785-pkwyuk-compressed-8_2%20IMG.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784880702-m66wam-compressed-8_2%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784900113-hbg0st-compressed-8_2%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784912410-tiry4y-compressed-8_2%20IMG.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756784962383-u4m206-compressed-8_2%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756784975847-texrfz-compressed-8_2%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756784987070-amyjvg-compressed-8_2%20IMG.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1756785041771-4hqdzz-compressed-8_2%20IMG.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1756785052892-jbn4si-compressed-8_2%20IMG.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1756785064901-bl9ghe-compressed-8_2%20IMG.jpg',
        },
        ph: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753697945699/2-pc.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753697945895/2-pad.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753697945544/2-h5.png',
        },
    };

    return (
        <div className={`${styles.GoLight} GtmModuleData-section`} data-section-id="GoLight" id="GoLight">
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="trail-layout light-items">
                <div className="light-item">
                    <div className="light-item-header">
                        <EcoImg className="light-item-img" pc={image1Map[locale].pc} pad={image1Map[locale].pad} h5={image1Map[locale].h5} />
                    </div>
                    {/* <div className="light-item-footer">{t('item1_title')}</div> */}
                </div>
                <div className="light-item">
                    <div className="light-item-header">
                        <EcoImg className="light-item-img" pc={image2Map[locale].pc} pad={image2Map[locale].pad} h5={image2Map[locale].h5} />
                    </div>
                    {/* <div className="light-item-footer">{t('item2_title')}</div> */}
                </div>
            </div>

            <div className="trail-layout footer-desc">{t('footer_desc')}</div>
        </div>
    );
};

export default GoLight;
